import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from '../styles/styles'

export class InfoPanel extends Component {

  static propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }

  render() {
    const { title, text } = this.props
      return (
          <div>
            <h4 style={styles.infoPanel.title}>{title}</h4>
            <div style={styles.infoPanel.text}>{text}</div>
          </div>
      )
  }
}

export default InfoPanel



// WEBPACK FOOTER //
// ./src/containers/InfoPanel.js